// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"6a3469c6","261":"8634a7be","337":"1de51f7b","465":"54ba0816","607":"b6599f60","876":"933aa2c2","916":"19d00d1d","981":"20839074"}[chunkId] + ".chunk.js";
};